import { Loading } from "element-ui";

let loading = null;
// 全局loading
const show = (name) => {
  loading = Loading.service({
    body: true,
    lock: true,
    text: name,
    background: "rgba(255, 255,255, 0.7)",
  });
};

const hide = () => {
  loading.close();
};

export default {
  show,
  hide,
};
